/** Assessments Types */
export const GET_ASSESSMENTS = 'GET_ASSESSMENTS';
export const GET_ASSESSMENTS_SUCCESS = 'GET_ASSESSMENTS_SUCCESS';

export const GET_ASSESSMENT_BY_ID = 'GET_ASSESSMENT_BY_ID';
export const GET_ASSESSMENT_BY_ID_SUCCESS = 'GET_ASSESSMENT_BY_ID_SUCCESS';

export const CREATE_ASSESSMENT = 'CREATE_ASSESSMENT';
export const SAVE_ASSESSMENT = 'SAVE_ASSESSMENT';
export const EDIT_ASSESSMENT = 'EDIT_ASSESSMENT';
export const DELETE_ASSESSMENT = 'DELETE_ASSESSMENT';

/** End */
